import { jsx as _jsx } from "react/jsx-runtime";
import React from "react";
import Box from "@mui/material/Box";
const DecorativeBackgroundBox = ({ side, top, transform, }) => {
    return (_jsx(Box, { sx: {
            display: { xs: "none", md: "block" },
            backgroundColor: "#F6F6F6",
            width: "60vw",
            height: "452px",
            position: "absolute",
            top,
            [side]: "0",
            transform,
            zIndex: -1,
        } }));
};
export default DecorativeBackgroundBox;
